import DropdownSelectCheck from '@/components/dropdown-select-check/dropdown-select-check';
import { GradesInfoModal, SubjectInfoModal } from '@/models/taxonomy/category-info';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { isEmptyValue, sortByProperty } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';
import MasteryCompetencyCompletionSetting from '../mastry-competency-completion-setting/mastery-competency-completion-setting';

@Component({
    name: 'mastery-content-completion',
    components: {
        'dropdown-select-check': DropdownSelectCheck,
        'mastery-competency-completion-setting': MasteryCompetencyCompletionSetting,
    },
})

export default class MasteryContentCompletion extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultMinScore: any = '0';

    @Prop()
    private contentLoader: any;

    @Prop()
    private tenantSettings: any;

    private defaultText: any = '';

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultText = tenantSettings.value;
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.$emit('onChangeConfig', this.defaultText);
    }

}
